import { Guid } from '@web/utils';
import { DictionaryCountry } from '@web/shared/module/dictionary';
import { AdminPaymentMethod } from './admin-payment-method';

export class AdminShippingMethodPrice {
  public constructor(
    private readonly data: {
      id: Guid;
      country: DictionaryCountry;
      price: number;
      paymentMethods: AdminPaymentMethod[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get country(): DictionaryCountry {
    return this.data.country;
  }

  public get price(): number {
    return this.data.price;
  }

  public get paymentMethods(): AdminPaymentMethod[] {
    return this.data.paymentMethods;
  }
}
